module.exports = __webpack_public_path__ + "static/media/alpha_16.eded677f.png";